import { Component, ChangeDetectionStrategy, Input, ChangeDetectorRef } from '@angular/core';

@Component({
    selector: 'data-source-component',
    template: '',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DataSourceComponent {
    @Input() data: Array<any> = [];

    constructor(protected ref: ChangeDetectorRef) {
    }

    refresh() {
        this.ref.detectChanges()
    }
}


// WEBPACK FOOTER //
// ./src/angular-shared-features/feature/shared-component/data-source.component.ts